import { AutogenModelAllLoadboardServices, AutogenRowAllLoadboardServices } from "./autogen/AutogenModelAllLoadboardServices";

export class ModelAllLoadboardServices extends AutogenModelAllLoadboardServices<RowAllLoadboardServices> {
	constructor() {
		super(RowAllLoadboardServices);
	}
}

export class RowAllLoadboardServices extends AutogenRowAllLoadboardServices {
}